import Typography from '@serko/zui/es/Typography';
import { TypographyProps } from '@serko/zui/es/Typography/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';

interface OwnProps extends TypographyProps {}

export interface ColumnMainTextProps extends OwnProps {}

const ColumnMainTextBase: FunctionComponent<ColumnMainTextProps> = props => (
  <Typography variant="subheading" lineClamp {...props} />
);

export const ColumnMainText = pure(ColumnMainTextBase);

ColumnMainText.displayName = 'ColumnMainText';
